import type { AnyObject, ColumnType } from "@similarweb/pro-logic-components";

import { getIndex } from "app/components/React/Table/cells/IndexCell";
import { switcherToDataIndexMap } from "app/pages/digital-marketing/ad-intelligence/common/shared/hooks/useSwitcherLogic";
import type { SwitcherOption } from "app/pages/digital-marketing/ad-intelligence/common/shared/ShareTypeSwitcher";

// Must match the pageSize passed to the Table's own `pagination` prop — the index
// column numbers rows by (currentPage, pageSize), so the two have to stay in sync.
export const TOP_INDUSTRIES_PAGE_SIZE = 5;

export const getTopIndustriesIndexColumn = <T = AnyObject>(currentPage: number): ColumnType<T> => ({
    width: 60,
    align: "center",
    shouldCellUpdate: () => true,
    render: (_line, _row, index) => getIndex(index, currentPage, TOP_INDUSTRIES_PAGE_SIZE),
});

export const VALUE_COLUMN_TITLE_KEYS = {
    spend: "ad.intelligence.publishers.spend.column.title",
    impressions: "ad.intelligence.publishers.impressions.column.title",
    visits: "ad.intelligence.publishers.visits.column.title",
} as const;

export type MetricKey = keyof typeof VALUE_COLUMN_TITLE_KEYS;
export type MetricShareKey = `${MetricKey}Share`;

export const getMetricKey = (selectedSwitcherOption: SwitcherOption): MetricKey =>
    switcherToDataIndexMap[selectedSwitcherOption] as MetricKey;

export const getIndustryLabel = (row: { category: string; subCategory?: string | null }): string =>
    row.subCategory ? `${row.category} > ${row.subCategory}` : row.category;

export const formatIndustryForAPI = <T extends { category: string; subCategory?: string | null }>(row: T): string => {
    const { category = "", subCategory = "" } = row ?? {};
    return `${category.replaceAll(" ", "_")}${subCategory ? `~${subCategory.replaceAll(" ", "_")}` : ""}`;
};
